export const quotes = [
  {
    name: "阿凯",
    role: "信息创作者",
    text: "有段时间反复刷到同一条「黑料」，差点就转发了。后来对照站里的证据梳理才发现是旧视频剪辑，帮我避了一次坑。",
    score: 96,
  },
  {
    name: "林女士",
    role: "家庭用户",
    text: "家里长辈群里天天传养生说法，我把站里的核查结论转过去，有理有据，比吵架管用多了。",
    score: 92,
  },
  {
    name: "小周",
    role: "在校学生",
    text: "做资料收集时最怕采到不实信息。这里把出处和时间线标得很清楚，引用起来心里有底。",
    score: 94,
  },
];

export const highlights = [
  { num: "1280+", label: "累计核查样本" },
  { num: "6+", label: "单条平均信源数" },
  { num: "340+", label: "已收录辟谣条目" },
  { num: "96%", label: "读者信任满意度" },
];